import {applyMiddleware, combineReducers, createStore} from 'redux';
import thunk, {ThunkMiddleware} from "redux-thunk";
import {composeWithDevTools} from '@redux-devtools/extension';
import {GeneralActionTypes} from './types/general';
import {generalReducer} from './reduxProperties/general/reducer';

export type AppActions = GeneralActionTypes;

const rootReducer = combineReducers({
    generalStore: generalReducer
});

export type AppState = ReturnType<typeof rootReducer>;

let storeToExport;

if (process.env.NODE_ENV === 'development') {
    storeToExport = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk as ThunkMiddleware<AppState, AppActions>)));
} else {
    storeToExport = createStore(rootReducer, applyMiddleware(thunk as ThunkMiddleware<AppState, AppActions>));
}

export const store = storeToExport;
